import { problemMessage } from '@/store/remote';
import { ApiError, NetworkError } from '@/services/http';

/** A mensagem para a tela de acesso: o motivo da API, ou o que fazer quando não há rede. */
export function authErrorMessage(error: unknown): string {
  if (error instanceof NetworkError) return 'Não foi possível falar com o servidor. Verifique sua conexão.';
  if (error instanceof ApiError && error.status === 429) {
    return 'Muitas tentativas seguidas. Espere um minuto e tente de novo.';
  }

  return problemMessage(error);
}

/** O `code` estável do problema (RFC 9457) devolvido pela API, quando há. */
export function problemCode(error: unknown): string | null {
  if (!(error instanceof ApiError) || typeof error.body !== 'object' || error.body === null) return null;

  const { code } = error.body as { code?: unknown };

  return typeof code === 'string' ? code : null;
}
